export default {
  light: {
    PRIMARY_COLOR: '#A0937D',
  },
  dark: {
    PRIMARY_COLOR: '#E7D4B5',
  },
}
